import { Link } from "./Link";

export const isLink = (item) => (item?.label || item?.icon) && item?.href 

export const RenderLink = ({item}) => (
    <Link href={item?.href} onClick={item?.handler}>
        {item?.icon}{item?.label}
    </Link>
)